import { AlpineComponent } from 'alpinejs';

import { alpineComponentNoStore } from '@/src/utilities/component-utilities';

export const imageCarouselMultiComponent =
  alpineComponentNoStore<ImageCarouselMultiComponent>(
    'imageCarouselMulti',
    factory
  );

function factory() {
  return {
    container: undefined as HTMLElement | undefined,
    prev: false,
    next: true,
    index: 1,
    totalItems: 0,
    initialized: false,

    init() {
      this.container = this.$refs['container'];
      if (!this.container) {
        return;
      }

      this.totalItems = Array.from(this.container.children).filter(
        (child) => child.tagName === 'LI'
      ).length;

      this.container.addEventListener('scroll', () =>
        this.updateNavigationState()
      );

      setTimeout(() => {
        this.initialized = true;
      }, 0);
    },

    updateNavigationState() {
      if (!this.container) return;

      const el = this.container;
      const children = Array.from(el.children).filter(
        (child) => child.tagName === 'LI'
      ) as HTMLElement[];

      const containerLeft = el.getBoundingClientRect().left;

      let minDiff = Infinity;
      let activeIndex = 0;

      children.forEach((child, i) => {
        const childLeft = child.getBoundingClientRect().left;
        const diff = Math.abs(childLeft - containerLeft);

        if (diff < minDiff) {
          minDiff = diff;
          activeIndex = i;
        }
      });

      this.index = activeIndex + 1;

      this.prev = el.scrollLeft > 1;

      const atEnd =
        Math.abs(el.scrollLeft + el.offsetWidth - el.scrollWidth) < 2;

      this.next = !atEnd && this.index < this.totalItems;
    },

    scrollToIndex(targetIndex: number) {
      const elements = Array.from(
        this.container?.children || []
      ) as HTMLElement[];

      if (!elements.length || targetIndex < 1 || targetIndex > elements.length)
        return;

      const targetEl = elements[targetIndex - 1];

      if (!targetEl) return;

      if (!this.container) return;

      const scrollLeft =
        targetEl.getBoundingClientRect().left -
        this.container.getBoundingClientRect().left +
        this.container.scrollLeft;

      this.container?.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
    },

    scrollToNext() {
      if (this.next) {
        this.scrollToIndex(this.index + 1);
      }
    },

    scrollToPrev() {
      if (this.prev) {
        this.scrollToIndex(this.index - 1);
      }
    },
  } as ImageCarouselMultiComponent;
}

interface ImageCarouselMultiComponent extends AlpineComponent {
  container: HTMLElement | undefined;
  prev: boolean;
  next: boolean;
  index: number;
  totalItems: number;
  initialized: boolean;

  updateNavigationState(): void;
  scrollToIndex(targetIndex: number): void;
  scrollToNext(): void;
  scrollToPrev(): void;
}
